import { render, staticRenderFns } from "./ViewPromotion.vue?vue&type=template&id=42bdd316&scoped=true"
import script from "./ViewPromotion.vue?vue&type=script&lang=js"
export * from "./ViewPromotion.vue?vue&type=script&lang=js"
import style0 from "./ViewPromotion.vue?vue&type=style&index=0&id=42bdd316&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdd316",
  null
  
)

export default component.exports